module.exports = __webpack_public_path__ + "img/img_ota.8a0d70cb.png";